'use client';

import { useField } from 'formik';

import { MaskedInput, type CommonMaskedInputProps } from 'src/shared/ui/MaskedInput';

import styles from '../index.module.css';

type FieldMaskedInputProps = Omit<CommonMaskedInputProps, 'name'> & {
  name: string;
};

export const FieldMaskedInput = ({ name, onChange, ...props }: FieldMaskedInputProps) => {
  const [field, meta] = useField<string | null>(name);

  return (
    <MaskedInput
      {...props}
      {...field}
      inputClassName={styles.fieldInput}
      fieldClassName={styles.controllerInput}
      value={field.value ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={meta.touched && meta.error ? meta.error : undefined}
    />
  );
};
